import { all } from "redux-saga/effects";
import authSaga from "./../features/authentication/authStore/saga";
import ipsSaga from "../features/ips/ipsStore/saga";
import notificationSaga from "../features/notifications/store/saga";
import messagesSaga from "../features/messages/store/saga";
import searchSaga from "../features/search/store/saga";
import commonSaga from "../features/common/store/saga";

export function* rootSaga() {
  yield all([
    authSaga(),
    ipsSaga(),
    notificationSaga(),
    messagesSaga(),
    searchSaga(),
    commonSaga(),
  ]);
}
